import { VStack } from '@components/Customized';
import { SearchInput } from '@components/SearchInput';
import { ProjectStatusType } from '@generated/graphql';
import { projectStatusToString } from '@utils/enumToString';
import { Dispatch, FunctionComponent, SetStateAction } from 'react';
import { SearchParam } from './useChatList';

interface ChatFilterProps {
  setSearchParam: Dispatch<SetStateAction<SearchParam>>;
}

const ChatFilter: FunctionComponent<ChatFilterProps> = ({ setSearchParam }) => {
  const onSubmit = ({
    keyword,
    tag
  }: {
    keyword?: string | null;
    tag?: string | null;
  }) => {
    setSearchParam({
      keyword: keyword ?? '',
      searchType: tag as ProjectStatusType
    });
  };

  return (
    <VStack padding={16}>
      <SearchInput
        onSubmit={onSubmit}
        options={Object.values(ProjectStatusType).map((value) => ({
          label: projectStatusToString(value),
          value
        }))}
      />
    </VStack>
  );
};

export default ChatFilter;
